import { useState, useEffect, Fragment } from 'react';
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faFacebookF, faTiktok } from '@fortawesome/free-brands-svg-icons';
import { faBars, faEnvelope, faPhone, faXmark } from '@fortawesome/free-solid-svg-icons';
import { fetchData } from '../utils';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [content, setContent] = useState({});

  const location = useLocation();
  const currentPath = location.pathname;

  useEffect(() => {
    fetchData('pageContent/kontakt', 'GET', null, (data) => {
      setContent(data);
    });

    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // блокировка скролла при открытом mobile menu
  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? 'hidden' : '';
  }, [isMenuOpen]);

  return (
    <Fragment>
        {/* ================= HEADER ================= */}
        <div className={`header flex ${isScrolled ? 'scrolled' : ''}`}>
            <div className="logo-on-header">
            <img
                className="logo-image"
                src="/LOGO_2_edited.png"
                alt=""
            />
            </div>

            {/* ===== DESKTOP MENU (НЕ ТРОГАЛ) ===== */}
            <div className="flex pages-of-header">
            <div>
                <a
                href="/"
                className={`uppercase underline ${currentPath === '/' ? 'active-link' : ''}`}
                >
                O firmie
                </a>
            </div>
            <div>
                <a
                href="/galeria"
                className={`uppercase underline ${currentPath === '/galeria' ? 'active-link' : ''}`}
                >
                Galeria
                </a>
            </div>
            <div>
                <a
                href="/kontakt"
                className={`uppercase underline ${currentPath === '/kontakt' ? 'active-link' : ''}`}
                >
                Kontakt
                </a>
            </div>
            <div>
                <a
                href="/wspolpraca"
                className={`uppercase underline ${currentPath === '/wspolpraca' ? 'active-link' : ''}`}
                >
                Współpraca
                </a>
            </div>
            </div>

            {/* ===== DESKTOP ICONS (НЕ ТРОГАЛ) ===== */}
            <div className="icons">
                <a href={`tel:${content.telefon}`}>
                    <FontAwesomeIcon style={{height: 20}} icon={faPhone} />
                </a>
                <a href={`mailto:${content.email}`}>
                    <FontAwesomeIcon style={{height: 20}} icon={faEnvelope} />
                </a>
                <a href="https://www.instagram.com/lux_sufity?igsh=MXNmNTl0MXFxeGpuNA%3D%3D&utm_source=qr">
                    <FontAwesomeIcon style={{height: 20}} icon={faInstagram} />
                </a>
                <a href="https://www.facebook.com/share/1ADLm7YU5U/?mibextid=wwXIfr">
                    <FontAwesomeIcon style={{height: 20}} icon={faFacebookF} />
                </a>
                <a href="https://www.tiktok.com/@luxsufitynapinane?_r=1&_t=ZN-92UXMeiFbTr">
                    <FontAwesomeIcon style={{height: 20}} icon={faTiktok} />
                </a>
            </div>

            {/* ===== BURGER (MOBILE) ===== */}
            <div className="burger" onClick={() => setIsMenuOpen(true)} aria-label="Open menu">
                <FontAwesomeIcon style={{color: 'white', fontSize: 23}} icon={faBars}/>
            </div>
        </div>

        {/* ================= MOBILE OVERLAY ================= */}
        <div
            className={`mobile-overlay ${isMenuOpen ? 'open' : ''}`}
            onClick={() => setIsMenuOpen(false)}/>

        {/* ================= MOBILE DRAWER ================= */}
        <aside className={`mobile-drawer ${isMenuOpen ? 'open' : ''}`}>
            <div className="mobile-drawer-header">
            <img
                src="/LOGO_2_edited.png"
                alt=""
                className="mobile-drawer-logo"
            />
            <button
                className="mobile-close"
                onClick={() => setIsMenuOpen(false)}
            >
                <FontAwesomeIcon icon={faXmark} />
            </button>
            </div>

            <nav className="mobile-drawer-nav">
            <a href="/" onClick={() => setIsMenuOpen(false)}>
                O firmie
            </a>
            <a href="/galeria" onClick={() => setIsMenuOpen(false)}>
                Galeria
            </a>
            <a href="/kontakt" onClick={() => setIsMenuOpen(false)}>
                Kontakt
            </a>
            <a href="/wspolpraca" onClick={() => setIsMenuOpen(false)}>
                Współpraca
            </a>
            </nav>

            <div className="mobile-drawer-footer">
            <a href={`tel:${content.telefon}`}>
                <FontAwesomeIcon icon={faPhone} />
            </a>
            <a href={`mailto:${content.email}`}>
                <FontAwesomeIcon icon={faEnvelope} />
            </a>
            <a href="https://www.instagram.com/lux_sufity?igsh=MXNmNTl0MXFxeGpuNA%3D%3D&utm_source=qr">
                <FontAwesomeIcon icon={faInstagram} />
            </a>
            <a href="https://www.facebook.com/share/1ADLm7YU5U/?mibextid=wwXIfr">
                <FontAwesomeIcon icon={faFacebookF} />
            </a>
            <a href="https://www.tiktok.com/@luxsufitynapinane?_r=1&_t=ZN-92UXMeiFbTr">
                <FontAwesomeIcon icon={faTiktok} />
            </a>
            </div>
        </aside>
    </Fragment>
  );
};

export default Header;
